import React, { Component } from 'react'
import Sidebar from './Sidebar';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router'
import { getHelpAndSupportData } from '../../../actions/jobseekerAction'

class HelpAndSupport extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        document.title = this.props.t('interest.title', { param: 'react' })
        this.props.getHelpAndSupportData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.helpSupportData !== this.props.helpSupportData) {
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
    }

    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }
        const Mainprops = this.props

        const { helpSupportData } = this.props;


        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div>
                                <div className="tab-content">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12 col-lg-12 mx-auto p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">{this.props.t("profileDetails.help_support", {
                                                                param: "react",
                                                            })}</h6>
                                                        </div>

                                                        <div className="panel-body">
                                                            <p>
                                                                Welcome to the Help & Support section of the DEGSDT Portal. <br />
                                                                This space is created to guide users through the key features and services available on the portal. Whether you're managing your profile, searching for jobs, downloading hall tickets, or registering for Job Melas, we’ve compiled easy-to-follow manuals to walk you through every process. These guides are here to help you make the most of your experience on the DEGSDT platform
                                                            </p>
                                                            <div class="table-responsive">
                                                                <div>
                                                                    {helpSupportData && helpSupportData.length > 0 ? (
                                                                        helpSupportData.map((item, index) => {
                                                                            return (
                                                                                <div className="mb-4" key={index}>
                                                                                    <h6 className='datetitle'>
                                                                                        <img src="/images/pdf.png" alt="pdf"/>
                                                                                        <a 
                                                                                        aria-label="Download {item?.title}"
                                                                                        className="date-clr" role="button" tabIndex="0" href={item?.file_path} target="_blank">{item?.title}</a>
                                                                                        <span className='pdf-size'> {item?.file_type} ({item?.size}) </span>
                                                                                    </h6>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    ) : (
                                                                        <p>No data available</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    helpSupportData: state.JobseekerReducer.getHelpSupportLis
});

const mapDispatchToProps = {
    getHelpAndSupportData
};

export default connect(mapStateToProps, mapDispatchToProps)(translate(HelpAndSupport));